import { render, staticRenderFns } from "./PageButton.vue?vue&type=template&id=5c6b6643&scoped=true&lang=pug&"
import script from "./PageButton.vue?vue&type=script&lang=ts&"
export * from "./PageButton.vue?vue&type=script&lang=ts&"
import style0 from "./PageButton.vue?vue&type=style&index=0&id=5c6b6643&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6b6643",
  null
  
)

export default component.exports